import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetSuspendedDataAlertSettingParams {
  user: string;
}

export interface IGetSuspendedDataAlertSettingResult extends IResult {
  enabled: boolean;
}
export class GetSuspendedDataAlertSettingRequest extends Request<IGetSuspendedDataAlertSettingParams, IResult> {
  constructor(params: IGetSuspendedDataAlertSettingParams) {
    super('getSuspendedDataAlertNotificationSetting', params);
  }
}
